import { render, staticRenderFns } from "./MyDocumentsList.vue?vue&type=template&id=940a0e14&scoped=true&"
import script from "./MyDocumentsList.vue?vue&type=script&lang=ts&"
export * from "./MyDocumentsList.vue?vue&type=script&lang=ts&"
import style0 from "./MyDocumentsList.vue?vue&type=style&index=0&id=940a0e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940a0e14",
  null
  
)

export default component.exports